import AuthenticatedController from './AuthenticatedController';
import * as APIRoutes from '@mm/api-routes';
import { GenericButtonModel, PageButtonConfig } from '../model/ButtonModel';

export class IceBreakerButtonController extends AuthenticatedController {
  static postIceBreakerButton(
    botId: number,
    iceBreakerId: number,
    entity: Partial<GenericButtonModel<PageButtonConfig>>,
  ): Promise<GenericButtonModel<PageButtonConfig>> {
    return super.post(
      APIRoutes.ICE_BREAKER_BUTTONS(botId, iceBreakerId),
      entity,
    );
  }

  static putIceBreakerButton(
    botId: number,
    iceBreakerId: number,
    entity: Partial<GenericButtonModel<PageButtonConfig>> & { id: number },
  ): Promise<GenericButtonModel<PageButtonConfig>> {
    return super.put(
      APIRoutes.ICE_BREAKER_BUTTON(botId, iceBreakerId, entity.id),
      entity,
    );
  }

  static deleteIceBreakerButton(
    botId: number,
    iceBreakerId: number,
    id: number,
  ): Promise<any> {
    return super.delete(APIRoutes.ICE_BREAKER_BUTTON(botId, iceBreakerId, id));
  }
}
